import { render, staticRenderFns } from "./SwaggerClient.vue?vue&type=template&id=5f7e3b87&scoped=true&"
import script from "./SwaggerClient.vue?vue&type=script&lang=js&"
export * from "./SwaggerClient.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f7e3b87",
  null
  
)

export default component.exports